/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2025 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2025 - Finnish Meteorological Institute (FMI)
 * Copyright 2025 - The Norwegian Meteorological Institute (MET Norway)
 * */

import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import type { InitialAppPreset } from '@opengeoweb/core';
import { getBeVersion, getInitialPresets } from './api';

export const useInitialPresets = (
  filename: string,
): UseQueryResult<InitialAppPreset, unknown> => {
  return useQuery<InitialAppPreset, unknown>({
    queryKey: ['initialPresets', filename],
    queryFn: async () => getInitialPresets(filename),
  });
};

export const useBeVersion = (): UseQueryResult<{ version: string }> =>
  useQuery({
    queryKey: ['be-version'],
    queryFn: async () => getBeVersion(),
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });
